// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c97209c8","800":"089be2ec"}[chunkId] + ".chunk.js";
};